// extracted by mini-css-extract-plugin
module.exports = {"basicProfile":"ProfileSettings_basicProfile__jtldE","avatar":"ProfileSettings_avatar__3RduP"};